import { render, staticRenderFns } from "./SecuritySettings.vue?vue&type=template&id=54b3b732&scoped=true"
import script from "./SecuritySettings.vue?vue&type=script&lang=js"
export * from "./SecuritySettings.vue?vue&type=script&lang=js"
import style0 from "./SecuritySettings.vue?vue&type=style&index=0&id=54b3b732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3b732",
  null
  
)

export default component.exports